import { z } from 'zod';
/**
 * Terheleses proba - a szerver, a parancssori futtato es az admin felulet
 * kozos szerzodese.
 */
export const loadTestInput = z.object({
    /** Egyideju szintetikus felhasznalok. */
    users: z.coerce.number().int().min(5).max(500).default(100),
    /** A forgalom hossza masodpercben (a felfutason felul). */
    seconds: z.coerce.number().int().min(10).max(900).default(60),
    /** Osszesitett uzenet/mp. */
    rate: z.coerce.number().min(0.1).max(50).default(2),
    /** Ennyi masodperc alatt kapcsolodik be mindenki. */
    ramp: z.coerce.number().int().min(1).max(120).default(15),
});
//# sourceMappingURL=loadtest.js.map